<script lang="ts">
	import type { Snippet } from "svelte";

	const { aria, children, id }: { aria: string; children: Snippet; id?: string } = $props();
</script>

<div class="contents">
	{@render children()}
	{#if aria}
		<!-- Google complains about some generic texts, this is a workaround, a simple aria-label is not enough -->
		<span class="sr-only" {id}>{aria}</span>
	{/if}
</div>
